<template>
  <div class="columns is-multiline">
    <div class="column is-12">
      <div class="columns">
        <div class="column is-4">
          <b-field label="Filteren">
              <b-input v-model="search"></b-input>
          </b-field>
        </div>
      </div>
    </div>

    <div class="column is-3" v-for="receipt in filteredList">
      <!-- <figure class="image is-autoby200">
        <img v-document="receipt.document">
      </figure> -->
      <div class="columns receipt_footer">
        <div class="column">
          <div class="box-footer">
            <div class="title is-6 spacing-top-10 spacing-bottom-10 no-margin-bottom">
              <h6 class="is-marginless"><b>Nr.</b> {{receipt.bonnummer}}</h6>
              <h6 class="is-marginless"><b>Datum.</b> {{receipt.datum | timezone | date}}</h6>
              <h6 class="is-marginless"><b>Crediteur:</b> {{receipt.crediteur | crediteur}}</h6>
              <h6 class="is-marginless"><b>Debiteur:</b> {{receipt.debiteur | debiteur}}</h6>
              <h6 class="is-marginless"><b>Bedrag chauffeur:</b> €{{receipt.ritprijsChauffeur}}</h6>
              <h6 class="is-marginless"><b>Bedrag klant:</b> €{{receipt.ritprijsFactuur}}</h6>
              <h6 class="is-marginless"><b>Kostenplaats:</b> {{receipt.kostenplaats}}</h6>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="nav-padding-fix column is-5" v-if="receipts.length <= 0">
      <article class="message is-info">
        <div class="message-header">
          <p>Geen bonnen gevonden</p>
        </div>
        <div class="message-body">
          Een bon moet bevestigd worden om aan deze lijst toegevoegd te worden.
        </div>
      </article>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      receipts: 'confirmedAndUnusedReceipts'
    }),
    filteredList () {
      return this.receipts.filter(receipt => {
        const search = this.search.toLowerCase()

        if (!search) {
          return true
        }

        for (let key in receipt) {
          const value = String(receipt[key]).toLowerCase()

          if (value.includes(search)) {
            return true
          }
        }

        return false
      })
    }
  },
  data () {
    return {
      search: ''
    }
  },
  async created () {
    await this.$store.dispatch('getConfirmedReceipts')
    await this.$store.dispatch('getDebiteuren')
    await this.$store.dispatch('getCrediteuren')
  }
}
</script>



// WEBPACK FOOTER //
// src/components/receipts/confirmed.vue